'use strict';

function trim(str) {
  return str.trim();
}

module.exports = trim;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/trim.js
// module id = 298
// module chunks = 0